<template>
  <div class="image-choice-item">
    <div class="mb-2 image-wrap">
      <el-image v-for="img in item.content.image" :key="img.url" :src="img.url" :preview-src-list="[img.url]"></el-image>
      <!--      <img v-for="img in item.content.image" :src="img.url" alt="" :key="img.url" />-->
    </div>
    <div class="px-3 py-2.5">
      <slot />
    </div>
    <slot name="vote"/>
  </div>
</template>

<script>
export default {
  name: 'ImageChoiceItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
